import React, { Component } from "react";
import BannerSlider from "./BannerSlider";
import Navbar from "./Navbar";
import {
  withContainers,
  ResizeContainer,
  BannerContainer,
} from "../../normalizer";
import { matchPath } from "react-router";

class Header extends Component {
  state = {
    mobileFriendly: false,
  };

  resize = () => {
    this.setState({
      mobileFriendly: window.innerWidth < 576,
    });
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize);
    this.resize();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }
  render() {
    const { mobileFriendly } = this.state;
    const {
      banner,
      campaign,
      toRender,
      fontFamily,
      banners,
      imageSize,
    } = this.props;
    const { pathname } = this.props.location;
    const bannersProps = banners.map((element, i) => {
      if (element && element.banner) {
        let size = imageSize;
        const croppedImageKey = size.replace("image", "cropped_image");
        const imageUrl =
          element.banner[croppedImageKey] && element.banner[croppedImageKey].url
            ? element.banner[croppedImageKey].url
            : element.banner[size]
            ? element.banner[size].url
            : "";

        return {
          gradient: element.banner.gradient_type,
          title: element.title,
          text: element.text,
          link: element.url,
          url: imageUrl,
          displayBanner: true,
        };
      } else {
        return {};
      }
    });

    const banner_exclusion_paths = [
      "profile",
      "cart",
      "supporting-documents",
      "analytics",
      "rankings",
      "news/*",
      "customized_pages/*",
      "quiz",
      "invoice",
      "catalog",
      "objectives",
      "sale-attributions",
      "sale-trading",
      "bonus_points",
      "dashboard"
    ];
    const excludeBanner = banner_exclusion_paths.some((p) => matchPath(pathname, { path: `/${p}` }));
    const headerClasses = ["default-bg gl-header"].join(" ");

    return (
      <>
        <Navbar
          logo={campaign.images.logo}
          gradient={campaign.gradient_type}
          toRender={toRender}
        />
        <header className={headerClasses}>
          {/* Inner container caps header content at 1440 + 48px side padding,
              matching .template-container + .gl-p-container (main content),
              .gl-navbar-header (navbar rows) and .gl-footer__container (footer).
              The outer <header> keeps the full-width background. */}
          <div className="gl-header__container">
            {/* TODO: get info from new campaign structure - gradient_type */}
            {!excludeBanner && (
              <BannerSlider
                data={bannersProps}
                mobileView={mobileFriendly}
                backgroundColor={
                  campaign.template &&
                  campaign.template.appearence &&
                  campaign.template.appearence.colors &&
                  campaign.template.appearence.colors["brand-default"]
                }
              />
            )}
          </div>
        </header>
      </>
    );
  }
}

export default withContainers(Header, [ResizeContainer, BannerContainer]);
